import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../../shared/shared.module';
import { AdminEditionComponent } from './admin-edition.component';
import { UserDetailsResolver } from '../user-details/user-details.resolver';
import { AssociationsListResolver } from '../../associations/associations-list/associations-list.resolver';

@NgModule({
    imports: [
      NgbModule,
      SharedModule
    ],
    declarations: [AdminEditionComponent],
    exports: [AdminEditionComponent],
    providers: [UserDetailsResolver, AssociationsListResolver]
  })
  export class AdminEditionModule {}
